// extracted by mini-css-extract-plugin
export default {"chartCard":"chart-card_chartCard__qEFTt","indicator":"chart-card_indicator__BcaBc","chartTop":"chart-card_chartTop__ga5ow"};